var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLinkBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 5h9V3H2v18h17v-2H4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6v2h2.58l-5.63 5.63 1.42 1.41L20 9.41V12h2V6z"
})));
export default SvgExternalLinkBold;